import React from 'react';
import { TemplateRenderProps } from './types';
import { FormFields, AddonsSelector, CouponSection, TrustAndSecurityBadge, SocialProofAndFomo } from './CheckoutCommonElements';
import { BillingCycleSelector, PriceBreakdown } from './CheckoutSummaryElements';

export const NeumorphicTemplate: React.FC<TemplateRenderProps> = ({
  plan,
  config,
  formData,
  onInputChange,
  billingCycle,
  onChangeCycle,
  selectedAddonIds,
  onToggleAddon,
  appliedCoupon,
  onApplyCoupon,
  onRemoveCoupon,
  onSubmitInfo,
  isCapturing,
  currencySymbol,
  addonsTotal,
  discountAmount,
  finalTotal,
}) => {
  return (
    <div
      className="min-h-full p-4 md:p-10 flex items-center justify-center bg-slate-200 text-slate-700"
      style={{
        fontFamily: config.fontFamily || 'Inter, sans-serif',
      }}
    >
      <div className="w-full max-w-xl bg-slate-200 rounded-[2.5rem] shadow-[20px_20px_60px_#bebebe,-20px_-20px_60px_#ffffff] p-6 md:p-10 space-y-6">
        <div className="text-center space-y-2">
          {config.logoUrl && <img src={config.logoUrl} alt="Logo" className="h-7 mx-auto object-contain" />}
          <h1 className="text-2xl font-black tracking-tight text-slate-800">{config.headerMain || `${plan.tier} Membership`}</h1>
          <p className="text-xs text-slate-500">{config.headerSub || 'Tactile, clean checkout experience.'}</p>
        </div>

        <div className="p-4 rounded-2xl bg-slate-200 shadow-[inset_6px_6px_12px_#bebebe,inset_-6px_-6px_12px_#ffffff] space-y-3">
          <BillingCycleSelector billingCycle={billingCycle} onChangeCycle={onChangeCycle} config={config} />
          <PriceBreakdown plan={plan} billingCycle={billingCycle} addonsTotal={addonsTotal} discountAmount={discountAmount} finalTotal={finalTotal} currencySymbol={currencySymbol} />
        </div>

        <SocialProofAndFomo config={config} />

        <form onSubmit={onSubmitInfo} className="space-y-4">
          <FormFields
            config={config}
            formData={formData}
            onInputChange={onInputChange}
            inputClassName="bg-slate-200 border-none shadow-[inset_4px_4px_8px_#bebebe,inset_-4px_-4px_8px_#ffffff] text-slate-800"
          />
          <AddonsSelector addons={config.addons} selectedAddonIds={selectedAddonIds} onToggleAddon={onToggleAddon} currency={plan.currency} />
          <CouponSection config={config} appliedCoupon={appliedCoupon} onApplyCoupon={onApplyCoupon} onRemoveCoupon={onRemoveCoupon} />

          <button
            type="submit"
            disabled={isCapturing}
            className="w-full py-4 bg-slate-200 text-slate-800 rounded-full font-black text-xs uppercase tracking-widest shadow-[6px_6px_12px_#bebebe,-6px_-6px_12px_#ffffff] active:shadow-[inset_4px_4px_8px_#bebebe,inset_-4px_-4px_8px_#ffffff] transition-all disabled:opacity-50"
          >
            {isCapturing ? 'Verifying...' : config.buttonText || `Confirm & Pay ${currencySymbol}${finalTotal.toFixed(2)}`}
          </button>
        </form>

        <TrustAndSecurityBadge config={config} />
      </div>
    </div>
  );
};
